import {Component, Input} from '@angular/core';
import {FileAttachmentApiService} from '@npck/af-frontend-api';
import {downloadFromBlobResponse, rxSpinner} from '@npck/libs/commons';
import {AttachmentViewModel} from '../documents-tab.component';

@Component({
    selector: 'af-documents-panel',
    templateUrl: './documents-panel.component.html',
    standalone: false,
})
export class DocumentsPanelComponent {
    @Input() id: string;
    @Input() attachments: AttachmentViewModel[];

    constructor(private fileAttachmentApiService: FileAttachmentApiService,
    ) {
    }

    downloadAllDocuments(): void {
        const fileIds = this.attachments?.map(filesWithType => filesWithType.files.map(file => file.file.id))
            .reduce((acc, curr) => {
                acc.push(...curr);
                return acc;
            }, []);
        this.fileAttachmentApiService.downloadFiles(fileIds, 'response')
            .pipe(rxSpinner(`documentsDownload_${this.id || 'common'}`))
            .subscribe(response => downloadFromBlobResponse(response));
    }
}
